module.exports = __webpack_public_path__ + "static/media/tmcf-feed-update-7-24.c7c4352d.png";